import React from 'react';
import { Box, Text, VStack, useColorModeValue } from '@chakra-ui/react';

// Simple markdown parser for onboarding content
function parseMarkdown(text, contentColor) {
  const lines = text.split('\n');
  const elements = [];
  let key = 0;

  lines.forEach((line, index) => {
    // Empty line - add spacing
    if (line.trim() === '') {
      elements.push(<Box key={`space-${key++}`} h="2" />);
      return;
    }

    // Bold headers (e.g., **Why Slack?**)
    if (line.match(/^\*\*.*\*\*$/)) {
      const text = line.replace(/\*\*/g, '');
      elements.push(
        <Text key={`header-${key++}`} fontWeight="700" fontSize="lg" color={contentColor} mt={index > 0 ? 3 : 0}>
          {text}
        </Text>
      );
      return;
    }

    // Numbered list items
    if (line.match(/^\d+\.\s/)) {
      const text = line.replace(/^\d+\.\s/, '');
      const parsed = parseInlineBold(text, contentColor, key);
      elements.push(
        <Text key={`num-${key++}`} fontSize="md" color={contentColor} pl={4} lineHeight="tall">
          {line.match(/^\d+\./)[0]} {parsed}
        </Text>
      );
      return;
    }

    // Bullet list items
    if (line.match(/^•\s/)) {
      const text = line.replace(/^•\s/, '');
      const parsed = parseInlineBold(text, contentColor, key);
      elements.push(
        <Text key={`bullet-${key++}`} fontSize="md" color={contentColor} pl={4} lineHeight="tall">
          • {parsed}
        </Text>
      );
      return;
    }

    // Regular text with possible inline bold
    const parsed = parseInlineBold(line, contentColor, key);
    elements.push(
      <Text key={`text-${key++}`} fontSize="md" color={contentColor} lineHeight="tall">
        {parsed}
      </Text>
    );
  });

  return elements;
}

// Parse inline bold text (**text**)
function parseInlineBold(text, contentColor, baseKey) {
  const parts = text.split(/(\*\*.*?\*\*)/g);
  
  return parts.map((part, i) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return (
        <Text key={`bold-${baseKey}-${i}`} as="span" fontWeight="700">
          {part.replace(/\*\*/g, '')}
        </Text>
      );
    }
    return part;
  });
}

export default function OnboardingStepContent({ title, content }) {
  const titleColor = useColorModeValue('secondaryGray.900', 'white');
  const contentColor = useColorModeValue('secondaryGray.700', 'secondaryGray.400');

  return (
    <VStack align="stretch" spacing={3} w="100%">
      <Text
        fontSize="2xl"
        fontWeight="700"
        color={titleColor}
        lineHeight="shorter"
        mb={3}
      >
        {title}
      </Text>
      <Box>
        {parseMarkdown(content, contentColor)}
      </Box>
    </VStack>
  );
}

